import React from 'react'
import Card from './card'
import mnmThumb from '../static/mnm-exports-thumb.png'
import mtThumb from '../static/monthly-tournament-thumb.png'
// import { FaGlobe } from 'react-icons/fa'

const workArray = [
    {
        title: 'MNM Exports',
        description: 'Web Designer, Web Developer',
        liveLink: 'https://mnmexports.com',
        thumb: mnmThumb
    },
    {
        title: 'Monthly Tournament',
        description: 'Web Designer, Backend developer',
        liveLink:'https://monthly-tournament.herokuapp.com/',
        thumb: mtThumb
    }
] 


const work = () => {
    return (
        <section className="h-auto md:h-screen mx-10 font-quicksand">
            <h2 className="text-5xl font-semibold font-quicksand my-20 text-center text-primary block"> <span className="p-2 canvas-hover"> Work History </span> </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 gap-10" >
                {workArray.map(work => (
                    <Card key={workArray.indexOf(work)} title={work.title} description={work.description}  liveLink={work.liveLink} thumb={work.thumb} />
                ))}
            </div>
        </section>
    )
}

export default work
